/**
 * 系统公告 | 常见问题 | 告警 | 错误日志
 */
import Net from '../net';

const NAME = '[MessageApi]';
const Log = (...p) => { console['log'](NAME, ...p); }


/** === SystemNotice === **/
/** system-notice/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.type
*/
export async function getSystemNoticeList(data = {}) {
  Log('getSystemNoticeList data:', data)
  try {
    const res = await Net.http('system-notice/list', { data })
    Log('getSystemNoticeList res:', res)
    return res
  } catch (err) {
    Log('getSystemNoticeList err:', err)
    throw err
  }
}

/** system-notice/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.type
 * @param {*} data.title
 * @param {*} data.content
*/
export async function createSystemNotice(data = {}) {
  Log('createSystemNotice data:', data)
  try {
    const res = await Net.http('system-notice/save', { data })
    Log('createSystemNotice res:', res)
    return res
  } catch (err) {
    Log('createSystemNotice err:', err)
    throw err
  }
}

/** system-notice/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getSystemNoticeDetail(data = {}) {
  Log('getSystemNoticeDetail data:', data)
  try {
    const res = await Net.http('system-notice/detail', { data })
    Log('getSystemNoticeDetail res:', res)
    return res
  } catch (err) {
    Log('getSystemNoticeDetail err:', err)
    throw err
  }
}

/** system-notice/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteSystemNotice(data = {}) {
  Log('deleteSystemNotice data:', data)
  try {
    const res = await Net.http('system-notice/delete', { data })
    Log('deleteSystemNotice res:', res)
    return res
  } catch (err) {
    Log('deleteSystemNotice err:', err)
    throw err
  }
}


/** === CommonQuestion === **/
/** common-problem/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.type
*/
export async function getCommonQuestionList(data = {}) {
  Log('getCommonQuestionList data:', data)
  try {
    const res = await Net.http('common-problem/list', { data })
    Log('getCommonQuestionList res:', res)
    return res
  } catch (err) {
    Log('getCommonQuestionList err:', err)
    throw err
  }
}

/** common-problem/add
 * @param {Object} data
 * @param {*} data.problem
 * @param {*} data.answer
 * @param {*} data.type
*/
export async function addCommonQuestion(data = {}) {
  Log('addCommonQuestion data:', data)
  try {
    const res = await Net.http('common-problem/add', { data })
    Log('addCommonQuestion res:', res)
    return res
  } catch (err) {
    Log('addCommonQuestion err:', err)
    throw err
  }
}

/** common-problem/update
 * @param {Object} data
 * @param {*} data.problem
 * @param {*} data.answer
 * @param {*} data.type
 * @param {*} data.id
*/
export async function commonQuestionEdit(data = {}) {
  Log('commonQuestionEdit data:', data)
  try {
    const res = await Net.http('common-problem/update', { data })
    Log('commonQuestionEdit res:', res)
    return res
  } catch (err) {
    Log('commonQuestionEdit err:', err)
    throw err
  }
}

/** common-problem/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteCommonQuestion(data = {}) {
  Log('deleteCommonQuestion data:', data)
  try {
    const res = await Net.http('common-problem/delete', { data })
    Log('deleteCommonQuestion res:', res)
    return res
  } catch (err) {
    Log('deleteCommonQuestion err:', err)
    throw err
  }
}


/** === Alarm === **/
/** alarm/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.source_type
 * @param {*} data.station_type_and_subject_list
 * @param {*} data.status
 * @param {*} data.device_uid
 * @param {*} data.flag_read
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function getAlarmList(data = {}) {
  Log('getAlarmList data:', data)
  try {
    const res = await Net.http('alarm/list', { data })
    Log('getAlarmList res:', res)
    return res
  } catch (err) {
    Log('getAlarmList err:', err)
    throw err
  }
}

/** alarm/save
 * @param {Object} data
 * @param {*} data.source_id
 * @param {*} data.source_type
 * @param {*} data.subject
 * @param {*} data.content
 * @param {*} data.data
*/
export async function createAlarm(data = {}) {
  Log('createAlarm data:', data)
  try {
    const res = await Net.http('alarm/save', { data })
    Log('createAlarm res:', res)
    return res
  } catch (err) {
    Log('createAlarm err:', err)
    throw err
  }
}

/** alarm/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getAlarmDetail(data = {}) {
  Log('getAlarmDetail data:', data)
  try {
    const res = await Net.http('alarm/detail', { data })
    Log('getAlarmDetail res:', res)
    return res
  } catch (err) {
    Log('getAlarmDetail err:', err)
    throw err
  }
}

/** alarm/event-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.page_size
 * @param {*} data.id
*/
export async function alarmEventList(data = {}) {
  Log('alarmEventList data:', data)
  try {
    const res = await Net.http('alarm/event-list', { data })
    Log('alarmEventList res:', res)
    return res
  } catch (err) {
    Log('alarmEventList err:', err)
    throw err
  }
}


/** === ErrorLog === **/
/** error-log/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.channel
 * @param {*} data.type
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.suid
*/
export async function getErrorLogList(data = {}) {
  Log('getErrorLogList data:', data)
  try {
    const res = await Net.http('error-log/list', { data })
    Log('getErrorLogList res:', res)
    return res
  } catch (err) {
    Log('getErrorLogList err:', err)
    throw err
  }
}

/** error-log/team-vin-start-error-list
 * @param {Object} data
 * @param {*} data.card_uid
 * @param {*} data.page
 * @param {*} data.page_size
*/
export async function errorLogTeamVinStartErrorList(data = {}) {
  Log('errorLogTeamVinStartErrorList data:', data)
  try {
    const res = await Net.http('error-log/team-vin-start-error-list', { data })
    Log('errorLogTeamVinStartErrorList res:', res)
    return res
  } catch (err) {
    Log('errorLogTeamVinStartErrorList err:', err)
    throw err
  }
}
